module.exports = __webpack_public_path__ + "img/logo-creative-tim.724cbfe8.svg";